import { setupSessionKeepalive } from "@utils/csrfUtils";
import { registerGlobalInitFunction } from "@/Registry";

registerGlobalInitFunction(setupSessionKeepalive);
